import { HoverCardWithLink } from '@/components/hover-card-with-link';
import { RoundedButton } from '@/components/rounded-button';
import { ARBITRUM_BRIDGE_URL, STARGATE_BRIDGE_URL } from '@/constants/shared';
import { getIconPathFromAppId } from '@/utils';
import { Heading, HStack, Image, Text, VStack } from '@chakra-ui/react';

const bridges = [
  {
    name: 'Stargate',
    appName: 'stargate_bridge',
    description: 'Bridge large amounts with low slippage',
    href: STARGATE_BRIDGE_URL,
  },
  {
    name: 'Arbitrum Bridge',
    appName: 'arb_native_bridge',
    description: 'Best for bridging large amounts of PLUME',
    href: ARBITRUM_BRIDGE_URL,
  },
];

const BridgeCard = ({
  name,
  description,
  href,
  appName,
}: {
  name: string;
  description: string;
  href: string;
  appName: string;
}) => {
  return (
    <HoverCardWithLink
      href={href}
      cardRootStyles={{
        w: 'full',
        p: [6, 6, 8],
        bg: 'bg',
        borderRadius: '16px',
      }}
      linkProps={{
        w: 'full',
      }}
    >
      <HStack gap={6} w="full">
        <Image src={getIconPathFromAppId(appName)} boxSize={10} borderRadius="md" />
        <VStack gap={1} alignItems="flex-start">
          <Heading fontSize="xl" fontWeight="700" lineHeight="28px" letterSpacing="-0.47px">
            {name}
          </Heading>
          <Text color="text.secondary" fontWeight="500">
            {description}
          </Text>
        </VStack>
      </HStack>
    </HoverCardWithLink>
  );
};

export const OtherBridgeInfo = () => {
  return (
    <VStack gap={5} w="full" alignItems="flex-start">
      <HStack justifyContent="space-between" w="full">
        <Heading fontSize="2xl" fontWeight="700" lineHeight="32px" letterSpacing="-0.47px">
          Other Bridges
        </Heading>
        <RoundedButton
          variant="outline"
          onClick={() => {
            window.open('/apps?type=Bridge', '_self');
          }}
        >
          See All
        </RoundedButton>
      </HStack>
      <VStack gap={5} w="full" alignItems="flex-start">
        {bridges.map((bridge) => (
          <BridgeCard key={bridge.name} {...bridge} />
        ))}
      </VStack>
    </VStack>
  );
};
